import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowFitTopLeft16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowFitTopLeft16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M2.001 3.501a1.5 1.5 0 0 1 1.5-1.5h6.964a.5.5 0 0 1 0 1H3.708L13 12.292V8.19h1V14H8.19a.5.5 0 0 1 0-1h4.104L3 3.707v6.757a.5.5 0 0 1-1 0zM13.499 8.19H13a.5.5 0 1 1 1 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconArrowFitTopLeft16);
